/* eslint-disable prettier/prettier */

import { apiService } from './api.service';

export interface LearnerGoal {
	id: string;
	title: string;

	goaltypename: string | null;

	status: string;

	relatedcourseid: string | null;
	coursetitle: string | null;

	currentvalue: number;
	targetvalue: number | null;

	unit: string;

	measurementtype: string | null;

	progresslabel: string;

	completionpct: number;
}

export interface Goal {
	id: string;
	title: string;
	status: string;
	progress: number;
	targetvalue: number | null;
	currentvalue: number | null;
	unit: string;

	programid: string;
	programtitle?: string;
}

export interface GoalListResponse {
	goals: Goal[];
	total: number;
	page: number;
	limit: number;
}
export const goalService = {
	async getLearnerGoalsForProgram(
		programId?: string
	): Promise<LearnerGoal[]> {
		try {
			const query = programId ? `?courseId=${programId}` : '';

			const response = await apiService.get<LearnerGoal[]>(
				`/goal/my-goals${query}`
			);

			if (!response.success) {
				throw new Error(response.message);
			}

			return response.data;
		} catch (error: any) {
			console.error('Get learner goals error:', error);

			throw new Error(error.message || 'Failed to fetch learner goals');
		}
	},

	async getGoals(filters: {
		userid?: string;
		programid?: string;
		istemplate?: boolean;
		status?: string;
		createdby?: string;
		page?: number;
		limit?: number;
	}): Promise<GoalListResponse> {
		try {
			const params = new URLSearchParams();

			if (filters.userid) {
				params.append('userid', filters.userid);
			}

			if (filters.programid) {
				params.append('programid', filters.programid);
			}

			if (filters.istemplate !== undefined) {
				params.append('istemplate', String(filters.istemplate));
			}

			if (filters.status) {
				params.append('status', filters.status);
			}

			if (filters.createdby) {
				params.append('createdby', filters.createdby);
			}

			params.append('page', String(filters.page || 1));

			params.append('limit', String(filters.limit || 20));

			const response = await apiService.get<GoalListResponse>(
				`/goal?${params.toString()}`
			);

			if (!response.success) {
				throw new Error(response.message);
			}

			return response.data;
		} catch (error: any) {
			throw new Error(error.message || 'Failed to fetch goals');
		}
	},
};
